export default __webpack_public_path__ + "static/media/like.6d1aa427.svg";